/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import { Card, Form, Button, Input, Col, Radio, message } from "antd";
import GenericTable from "../../components/GenericTable";
import PageToolbar from "../../components/PageToolbar";
import GenericSelector from "../../components/GenericSelector";
import LangContext from "../../contextProvider/LangContext";
import { Row } from "antd/es/grid";
import DateTimePicker from "../../components/DateTimePicker";
import moment from "moment";
import ReportExcelBtn from "../../components/ReportExcelBtn";
import { Job, OutputType, ProcessType, User } from "../../JmReact";

const curdate = moment();

class DailySalesAndReceiptsExcel extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            fromDate: curdate.format("YYYY-MM-01"),
            toDate: curdate.format("YYYY-MM-DD"),
            concatBranchesByAreas: "0",
        };
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        document.title = "Cash On Tab - " + this.getText(22453);
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    onCreateExcel = (next) => {
        if(!this.state.fromDate || !this.state.toDate) {
            message.error(this.getText(22462))
            return;
        }
        this.sendAPI("get_daily_sales_and_receipts_excel", this.state, (ob => {
            let data = []
            let mergesList = []
           
            if (ob.data) {

                let dataset = []

                const fullDataset = ob.data.split("\r").map(x => {
                    const [_sales, _id, _name, _group, _groupName, _docDate, _sum] = x.split("\f");
                    return { _sales, _id, _name, _group, _groupName, _docDate, _sum }
                })

                let groups = [...new Set(fullDataset.map(x => x._group + "#" + x._groupName))].map(x => {
                    const [_group, _groupName] = x.split("#");
                    return { _group, _groupName }
                })

                let cols = [...new Set(fullDataset.map(x => x._sales + "#" + x._id + "#" + x._name))].map(x => {
                    const [_sales, _id, _name] = x.split("#");
                    return { _sales, _id, _name }
                })

                cols = [
                    ...cols.filter(x => x._sales === "1").sort((a, b) => (a._id == 1 ? 100 : a._id) - (b._id == 1 ? 100 : b._id)),
                    ...cols.filter(x => x._sales !== "1").sort((a, b) => a._id - b._id)
                ]

                let dates = [...new Set(fullDataset.map(x => x._docDate))].map(x => x);

                let r1 = [""]
                let r2 = [""]
                groups.forEach(g => {
                    let sc = r1.length;
                    let spaceCount = parseInt((cols.length * 21) - (g._groupName.length / 2));
                    r1.push([...Array(spaceCount).fill(" ")].join("") + g._groupName)
                    r1.push(...Array(cols.length - 1).fill(""))
                    let ec = r1.length - 1;
                    mergesList.push({ s: { r: 0, c: sc }, e: { r: 0, c: ec } })
                    cols.forEach(c => { r2.push(c._name) })
                })
                data.push(r1)
                data.push(r2)

                dates.forEach(d => {
                    let r = [d]
                    groups.forEach(g => {
                        cols.forEach(c => {
                            let f = fullDataset.find(x => x._docDate === d && x._group === g._group && x._sales === c._sales && x._id === c._id)
                            r.push(f ? f._sum : "0.00")
                        })
                    })
                    data.push(r)
                })
            }
            next([{ name: "DailySalesAndReceipts", data, mergesList }])
        }))
    }

    render() {
        const gt = this.getText;

        const divStyle = {
            direction: "rtl",
            padding: "2% 2% 2% 2%",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            flexDirection: 'column',
        };

        return (
            <div style={divStyle}>
                <Card
                    title={(<PageToolbar title={gt(22453)} showsearch={false} actionButtons={[]} />)}
                    bordered={true}
                    style={{ width: window.innerWidth < 800 ? '95%' : 800 }}
                    headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                    actions={[
                        <ReportExcelBtn
                            {...this.props}
                            btnStyle
                            btnType="primary"
                            btnText={gt(22459)}
                            reportName={"DailySalesAndReceipts"}
                            getDatasetOnClick={this.onCreateExcel}
                        />]}
                >
                    <Row>
                        <Col span={window.innerWidth > 600 ? 10 : 24}>
                            <Form.Item label={gt(22454)}>
                                <DateTimePicker
                                    format={"DD/MM/YYYY"}
                                    value={this.state.fromDate}
                                    onChange={e => { this.setState({ fromDate: e }) }}
                                    minDate={this.state.toDate? moment(this.state.toDate).add(-100, 'day').format("YYYY-MM-DD") : null}
                                    maxDate={this.state.toDate}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={window.innerWidth > 600 ? 10 : 24}>
                            <Form.Item label={gt(22455)}>
                                <DateTimePicker
                                    format={"DD/MM/YYYY"}
                                    value={this.state.toDate}
                                    onChange={e => { this.setState({ toDate: e }) }}
                                    minDate={this.state.fromDate}
                                    maxDate={this.state.fromDate ? moment(this.state.fromDate).add(100, 'day').format("YYYY-MM-DD") : null}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={window.innerWidth > 600 ? 4 : 24}>
                            <Button type="primary" style={{ marginTop: 30 }} onClick={() => {
                                const fromDate = moment().add(-1, 'month').format("YYYY-MM-01");
                                const toDate = moment(moment().format("YYYY-MM-01")).add(-1, 'day').format("YYYY-MM-DD");
                                this.setState({ fromDate, toDate });
                            }}>{gt(22456)}</Button>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Radio.Group
                            onChange={e => { this.setState({ concatBranchesByAreas: e.target.value }) }}
                            value={this.state.concatBranchesByAreas}>
                            <Radio value={"0"}>{gt(22457)}</Radio><br />
                            <Radio value={"1"}>{gt(22458)}</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Card>

            </div>)

    }

}

export default DailySalesAndReceiptsExcel;